module.exports = __webpack_public_path__ + "static/arrunada-logo-main-1b033c7d8def2dac2c066389e6f26e1d.svg";